import styled from "styled-components";

export const Wrapper = styled.h2`
  font-weight: normal;
  font-size: 1em;
`;
